import React from 'react';
import { IEntityToken } from '../../API';
import { Stack, StackItem, TextField } from '@fluentui/react';
import ExpressionField, { ExpressionFieldState } from '../pages/expression-builder/ExpressionField';
import { ExpressionBuilderOutputType } from '../pages/expression-builder/ExpressionBuilder';
import { makeAutoObservable } from 'mobx';
import { observer } from 'mobx-react';

export interface ITokenPathTagPickerProps {
	state: TokenPathTagPickerState;
}

export class TokenPathTagPickerState {

	placeholder?: string;
	prefix?: string;
	value?: string;
	tokens: IEntityToken[];
	setValueCallback?: (newPath:string) => void;

	constructor(setValueCallback: (newPath:string) => void, placeholder:string, prefix:string|undefined, value:string, tokens:IEntityToken[]) {
		this.placeholder = placeholder;
		this.prefix = prefix;
		this.value = value;
		this.tokens = tokens;
		this.setValueCallback = setValueCallback;
		makeAutoObservable(this);
	}

	setValue(newValue: string) {
		this.value = newValue;
		this.setValueCallback?.(newValue);
	}
}

class TokenPathTagPicker extends React.Component<ITokenPathTagPickerProps, {}> {
	
	render(): React.ReactNode {

		let expState = new ExpressionFieldState(ExpressionBuilderOutputType.String, (newExpression:string) => {
						this.props.state.setValue(newExpression);
					}, this.props.state.value)

		expState.setAvailableTokens(this.props.state.tokens);

		return <Stack horizontal grow>
			<StackItem grow>
				<TextField
					prefix={this.props.state.prefix}
					value={this.props.state.value}
					onChange={(_, newValue) => {
						this.props.state.setValue(newValue || '');
					}}
					placeholder={this.props.state.placeholder}
				/>
			</StackItem>

			<StackItem>
				<ExpressionField
					iconButton={true}
					state={expState}
				/>
			</StackItem>
		</Stack>;
	} 
}

export default observer(TokenPathTagPicker);